import HighlightText from '@common/components/highlighText';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const RacingResultItem = ({
  region, onSelectGame, search, sportType, alwaysOpen, routePrefix
}) => {
  const navigate = useNavigate();
  const [closed, setClosed] = useState(false);

  const dwopDownClick = () => {
    setClosed(!closed);
  };

  useEffect(() => setClosed(false), [alwaysOpen]);

  return (
    <div className={`region-container ${closed ? 'closed' : ''}`} key={region.id} onClick={!alwaysOpen ? dwopDownClick : undefined}>
      <div className="region-name-container">
        <div className="regionName-Flag">
          <span className={`flag icon-${region.alias?.toLowerCase().replaceAll(' ', '')} flag`} />
          <span>{region.name}</span>
        </div>
        {!alwaysOpen && (
          <div className="arrow-section">
            {closed
              ? <i className="global-icon icon-thin-arrow-down" />
              : <i className="global-icon icon-thin-arrow-up" />}
          </div>
        )}
      </div>
      {!closed && (
        <div className="competition-container">
          {region.competitions.map((comp) => (
            <div
              key={comp.id}
              className="competition"
              onClick={() => navigate(`${routePrefix}/racings/${sportType}/result/${region.alias}/${comp.id}/${comp.matchId}`)}
            >
              <div className="competition-name">
                <HighlightText text={comp.name} highlightPart={search} />
              </div>
              <div className="game-container">
                {comp.games.filter((game) => !!game?.start_ts).map((game) => (
                  <div
                    key={game.id}
                    className="game"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelectGame(e, region.alias, region.id, comp.id, game.id);
                    }}
                  >
                    {moment.unix(game.start_ts).format('HH:mm')}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RacingResultItem;
